import { reduceMotion } from '@js/animations/ReducedMotion'
import { createOnceOnEnter } from '@js/animations/scrollTriggerHelper'

export class Wipe {
  constructor () {
    this._elements = document.querySelectorAll('[animation-wipe]')

    if (!this._elements.length) {
      return
    }

    this.init()
  }

  init () {
    this._elements.forEach((el) => {
      if (reduceMotion) {
        el.classList.add('animation-wipe--active')
        return
      }

      createOnceOnEnter({
        trigger: el,
        onEnter: () => {
          el.classList.add('animation-wipe--active')
        },
      })
    })
  }
}
